module.exports = __webpack_public_path__ + "img/Mitre-10-logo.ccc7d0f9.png";